// File: src/App.tsx
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";

import LandingPage from "./components/LandingPage";
import Dashboard from "./pages/Dashboard";
import ListBoots from "./pages/ListBoots";
import FindSwapV2 from "./pages/FindSwapV2";
import ListBoot from "./pages/ListBoot";
import MyStuff from "./pages/MyStuff";
import SwapOptionsPage from "./pages/SwapOptionsPage";
import FindSwapPage from "./pages/FindSwap";
import AdminInterests from "./pages/AdminInterests";
import AdminSearchAudit from "./pages/AdminSearchAudit";
import ReplyPage from "./pages/ReplyPage";

import BootsAvailable from "./pages/BootsAvailable";
import BootDetail from "./pages/BootDetail";

import AppHeader from "./components/AppHeader";
import AppFooter from "./components/AppFooter";

const NewChromeLayout: React.FC = () => (
  <div className="app-container">
    <AppHeader />
    <main className="main-content">
      <Outlet />
    </main>
    <AppFooter />
  </div>
);

const ReplyLayout: React.FC = () => (
  <div className="app-container">
    <main className="main-content">
      <Outlet />
    </main>
  </div>
);

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />

        {/* Reply: no header/footer */}
        <Route element={<ReplyLayout />}>
          <Route path="/reply" element={<ReplyPage />} />
        </Route>

        {/* Main app: header/footer */}
        <Route element={<NewChromeLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />

          {/* Browse listings */}
          <Route path="/boots" element={<BootsAvailable />} />
          <Route path="/boots/:listingId" element={<BootDetail />} />

          <Route path="/list-boots" element={<ListBoots />} />
          <Route path="/find-swap-v2" element={<FindSwapV2 />} />
          <Route path="/list-boot" element={<ListBoot />} />

          {/* Canonical MyStuff */}
          <Route path="/my" element={<MyStuff />} />

          {/* Backward compatible alias */}
          <Route path="/my-stuff" element={<Navigate to="/my" replace />} />

          <Route path="/swap-options-v2" element={<SwapOptionsPage />} />
          <Route path="/find-swap-v2-old" element={<FindSwapPage />} />

          <Route path="/admin/interests" element={<AdminInterests />} />
          <Route path="/admin/search-audit" element={<AdminSearchAudit />} />
        </Route>
      </Routes>
    </Router>
  );
}